module.exports = __webpack_public_path__ + "static/img/why-4.5156633e.jpg";